import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Survey from "@/pages/Survey";
import ChildrenRegister from "@/pages/ChildrenRegister";
import Admin from "@/pages/Admin";
import { TermsPage, PrivacyPage } from "@/pages/Legal";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/survey" element={<Survey />} />
          <Route path="/children" element={<ChildrenRegister />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
